import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class HttpService {


  httpOptions = {
    headers: new HttpHeaders()
    .set('content-type', 'application/json')
    .set('Accept', 'application/json')
    // .set('Access-Control-Allow-Headers', 'Content-Type')
    // .set('Access-Control-Allow-Methods','GET,POST,OPTIONS,DELETE,PUT')
   // .set('Access-Control-Allow-Origin', '*')
  };

  //BACKEN_PATH = 'http://localhost:3003/';
  BACKEN_PATH = 'https://argoappswebpage.herokuapp.com/';


  constructor(public http: HttpClient) {}


  post(path: string,body: any){
    return new Promise( (resolve, reject)=> {
      this.http.post(this.BACKEN_PATH + path, body, this.httpOptions).subscribe((response) => {
        resolve(response);
      },(error) => {
        reject(error);
      });
    });
  }

  get(path: string){
    return new Promise( (resolve, reject) => {
      this.http.get(this.BACKEN_PATH + path, this.httpOptions).subscribe((response) => {
       resolve(response);
      },(error) => {
        reject(error);
      });
    });
  }


}
